/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Other_ReqInputs */

const en_fc_dl_other_req = /** @type {(inputs: Fc_Dl_Other_ReqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web build for any static host · FreeBSD x86_64 tarball`)
};

/**
* | output |
* | --- |
* | "Web build for any static host · FreeBSD x86_64 tarball" |
*
* @param {Fc_Dl_Other_ReqInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_other_req = /** @type {((inputs?: Fc_Dl_Other_ReqInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Other_ReqInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_other_req(inputs)
});
export { fc_dl_other_req as "fc.dl.other.req" }